export const WEEKS = 10;
